export const VOUCHER_CREATE_FORM_ID = Symbol();
